import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class FirmService extends HeaderService {

    getFirmsForSuperAdmin(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getFirmsForSuperAdmin',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAllFirms(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-all-firms',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getNonInstallationFirms(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getNonInstallationFirmsForSuperAdmin',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-firm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createFirm(firm: any): Observable<any> {

        return this.http.post(environment.apiBaseUrl + 'firm',
            JSON.stringify(firm),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteFirm(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'get-firm/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getFirmPaymentMethod(): Observable<any> {
        return Observable.of([
            {
                value: 'param',
                displayValue: 'PARAM',
                status: true
            },
            {
                value: 'iyzico',
                displayValue: 'IYZICO',
                status: false
            },
            {
                value: 'papara',
                displayValue: 'PAPARA',
                status: false
            }
        ]);
    }

    getAllFirmIfHaveStorageCard(paymendMethod: string): Observable<any> {
        return this.http.get(environment.apiBaseUrl + `payment/${paymendMethod}/firmList`,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    paymentForParam(KS_GUID: string, KK_Sahibi_GSM: string, Toplam_Tutar: string, firmId: any): Observable<any> {
        return this.payment({
            KS_GUID, KK_Sahibi_GSM, Toplam_Tutar, firmId
        }, 'param');
    }

    payment(paymentData: any, paymendMethod: string): Observable<any> {
        return this.http.post(environment.apiBaseUrl + `payment/${paymendMethod}/payWithCardStorage`, paymentData,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/firm.service.ts